import { EntityReportTab, ENTITY_REPORT_VARIANT } from 'components/EntityReportTab';

export const ReportTab = ({ building, onNavigateToApplications }) => (
  <EntityReportTab
    variant={ENTITY_REPORT_VARIANT.EMAIL_OR_DELEGATED_BUILDING_COMPACT}
    building={building}
    onNavigateToApplications={onNavigateToApplications}
  />
);
